/**
 * The marketing pages that are live. One list, read by every app on both dev
 * and prod: the page guard 404s anything not here, and the header, footer,
 * services menu and sitemap only link what is here. Launching a page is adding
 * its path to this array — nothing else, nowhere else.
 */
export const LAUNCHED_ROUTES = [
  '/',
  '/remove-leaked-onlyfans-content',
  '/for-agencies',
  '/how-it-works',
  '/contact',
  '/terms-and-conditions',
  '/privacy-policy',
] as const;

/** Whether a path is a launched marketing page (trailing slash and query ignored). */
export function isLaunched(path: string): boolean {
  const clean = (path.split('?')[0].split('#')[0].replace(/\/+$/, '') || '/');
  return (LAUNCHED_ROUTES as readonly string[]).includes(clean);
}
